export function mapLeaderboardEntries<Row, Entry, Context>(
  rows: ReadonlyArray<Row>,
  isResolved: boolean,
  mapRow: (row: Row, context: Context) => Entry | null,
  context: Context,
): ReadonlyArray<Entry> {
  return isResolved ? mapCompleteRows(rows, mapRow, context) : [];
}

export function readFiniteNumber<Value>(value: Value): number | null {
  if (value === null || value === undefined || value === '') return null;

  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
}

export function readFiniteNumericString<Value>(value: Value): string | null {
  return readFiniteNumber(value) === null ? null : String(value);
}

function mapCompleteRows<Row, Entry, Context>(
  rows: ReadonlyArray<Row>,
  mapRow: (row: Row, context: Context) => Entry | null,
  context: Context,
): ReadonlyArray<Entry> {
  const entries: Entry[] = [];

  for (const row of rows) {
    const entry = mapRow(row, context);
    if (entry !== null) entries.push(entry);
  }

  return entries;
}
